import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import {
  IFilterComponent,
  SearchFilter,
} from "src/app/infrastructure/iFilter-component";
import { PhysicianFilter } from "src/app/model/physician-Filter";
import { PracticeRegionFilter } from "src/app/model/practice-region-filter";
import { SpecialityFilter } from "src/app/model/speciality-filter";
import { SearchMedicalReportHistorialRequest } from "src/app/model/study-report/search-medical-report-historial-request";
import { StudyRegionFilter } from "src/app/model/study-report/study-region-filter";
import { FilterRecordService } from "src/app/services/filter-record.service";
import { FilterService } from "src/app/services/filter.service";
import { MedicalServiceService } from "src/app/services/medical-service.service";
import { StudyReportService } from "src/app/services/study-report/study-report.service";

@Component({
  selector: "app-study-report-historial-filter",
  templateUrl: "./study-report-historial-filter.component.html",
  styleUrls: ["./study-report-historial-filter.component.css"],
})
export class StudyReportHistorialFilterComponent
  implements IFilterComponent, OnInit
{
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement!: ElementRef;

  filterCompletePracticeRegions: FilterCompleteService<PracticeRegionFilter>;
  filterCompleteReportRegions: FilterCompleteService<StudyRegionFilter>;
  filterCompleteReportingPhysicians: FilterCompleteService<PhysicianFilter>;
  filterCompleteSpecialties: FilterCompleteService<SpecialityFilter>;

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private medicalServiceService: MedicalServiceService,
    private studyReportService: StudyReportService,
    private filterRecordService: FilterRecordService
  ) {
    this.form = this.formBuilder.group({
      DateFrom: [null, Validators.required],
      DateTo: [null, Validators.required],
      Protocol: [""],
      PracticeRegion: [null],
      ReportRegion: [null],
      ReportingPhysician: [null],
      Specialty: [null],
    });

    this.filterCompletePracticeRegions = new FilterCompleteService<PracticeRegionFilter>(
      [],
      this.form.controls.PracticeRegion
    );
    this.filterCompleteReportRegions = new FilterCompleteService<StudyRegionFilter>(
      [],
      this.form.controls.ReportRegion
    );
    this.filterCompleteReportingPhysicians = new FilterCompleteService<PhysicianFilter>(
      [],
      this.form.controls.ReportingPhysician
    );
    this.filterCompleteSpecialties = new FilterCompleteService<SpecialityFilter>(
      [],
      this.form.controls.Specialty
    );
  }

  get f() {
    return this.form.controls;
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "StudyReportHistorialFilterComponent",
      this.form
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "StudyReportHistorialFilterComponent",
      this.form
    );
  }

  getSearchFilters(): SearchFilter[] {
    return this.filterRecordService.convertToSearchFilters(this.form, [
      "DateFrom",
      "DateTo",
    ]);
  }

  get filteredPracticeRegionsOptions() {
    return this.filterCompletePracticeRegions
      ? this.filterCompletePracticeRegions.filteredOptions
      : [];
  }

  get filteredReportRegionsOptions() {
    return this.filterCompleteReportRegions
      ? this.filterCompleteReportRegions.filteredOptions
      : [];
  }

  get filteredReportingPhysiciansOptions() {
    return this.filterCompleteReportingPhysicians
      ? this.filterCompleteReportingPhysicians.filteredOptions
      : [];
  }

  get filteredSpecialtiesOptions() {
    return this.filterCompleteSpecialties
      ? this.filterCompleteSpecialties.filteredOptions
      : [];
  }

  async search(): Promise<any> {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return [];
    }

    const request = new SearchMedicalReportHistorialRequest();
    request.FromDate = this.form.controls.DateFrom.value || undefined;
    request.ToDate = this.form.controls.DateTo.value || undefined;
    request.Protocol = this.form.controls.Protocol.value || undefined;
    request.PracticeRegionId = this.form.controls.PracticeRegion.value
      ? this.form.controls.PracticeRegion.value.Id
      : undefined;
    request.ReportRegionId = this.form.controls.ReportRegion.value
      ? this.form.controls.ReportRegion.value.Id
      : undefined;
    request.ReportingPhysicianId = this.form.controls.ReportingPhysician.value
      ? this.form.controls.ReportingPhysician.value.Id
      : undefined;
    request.SpecialtyId = this.form.controls.Specialty.value
      ? this.form.controls.Specialty.value.Id
      : undefined;

    return await this.studyReportService.searchMedicalReportHistorial(request);
  }

  ngOnInit(): void {
    this.filterService.getPracticesRegionFilter().then((practiceRegions) => {
      this.filterCompletePracticeRegions = new FilterCompleteService<PracticeRegionFilter>(
        practiceRegions,
        this.form.controls.PracticeRegion
      );
    });

    this.medicalServiceService.getStudyRegionFilter().then((regions) => {
      this.filterCompleteReportRegions = new FilterCompleteService<StudyRegionFilter>(
        regions,
        this.form.controls.ReportRegion
      );
    });

    this.filterService.getPhysiciansFilter().then((physicians) => {
      this.filterCompleteReportingPhysicians = new FilterCompleteService<PhysicianFilter>(
        physicians,
        this.form.controls.ReportingPhysician
      );
    });

    this.filterService.getSpecialtiesFilter().then((specialties) => {
      this.filterCompleteSpecialties = new FilterCompleteService<SpecialityFilter>(
        specialties,
        this.form.controls.Specialty
      );
    });
  }
}
